import {
  initImgUpload,
  uploadcompleteImg,
  uploadImgS3Bucket,
} from "../../service/apiService";
import { useFormContext } from "../contexts/FormContext";

const useImageUpload = () => {
  const { formValues } = useFormContext();
  const handleUpload = async () => {
    try {
      const { customerNumber, conceptID } = formValues;
      const file = globalThis.selectedPolygonImageFile;

      if (!file) {
        console.error("No image file found to upload");
        return;
      }

      const data = await initImgUpload({
        customerNumber: customerNumber,
        conceptId: conceptID,
        fileType: "png",
      });
      const { uploadKey, uploadUrl } = data;
      if (uploadUrl && uploadKey) {
        const uploadResponse = await uploadImgS3Bucket(uploadUrl, file);
        if (uploadResponse.ok) {
          await uploadcompleteImg({ uploadKey: uploadKey });
        }
      }
    } catch (err) {
      console.error("Error uploading image:", err);
    }
  };

  return {
    handleUpload,
  };
};

export default useImageUpload;
